import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, Typography } from '@material-ui/core';

import { useStylesMUI } from '../../../../styles/home/style';
import { TempABM } from '../../../atomic/templates/TempABM';
import { required } from '../../../../helpers/validations/validators';
import { deleteTipoDocumentacionSolicitudIntegracion, getAllTiposDocumentacionIntegracion, getAllTiposDocumentacionSolicitudIntegracion, getTiposSolicitudesDiscapacidad, guardarTipoDocumentacionSolicitudIntegracion } from '../../../../actions/discapacidad/discapacidadActions';
import { SelectValidatorGeneric } from '../../../atomic/atoms/Select';

export const TipoDocumentacionSolicitudIntegracionAbm = () => {
    const dispatch = useDispatch();
    const classes = useStylesMUI();

    const { tiposDocumentacionAbm, tiposDocumentacion, tiposSolicitudes } = useSelector(state => state.discapacidad)

    useEffect(() => {
        dispatch(getAllTiposDocumentacionSolicitudIntegracion());
        dispatch(getAllTiposDocumentacionIntegracion());
        dispatch(getTiposSolicitudesDiscapacidad());
    }, []);

    return (
        <div className={classes.root}>
            <TempABM
                gridProps={{ md: 10 }}
                tableProps={{
                    sizeTableCells: ["10%", "20%", "20%", "10%", "10%"]
                }}
                titles={{
                    abm: 'Tipo Documentación Integración Solicitud',
                    insert: 'Agregar Tipo Documentación',
                    update: 'Modificar Tipo Documentación',
                    delete: 'Eliminar Tipo Documentacion',
                    deleteMsg: "Desea Eliminar este Tipo de Documentación Solicitud?"
                }}
                data={(data) => ({
                    idTipoDocSolicitud: data?.idTipoDocSolicitud || '',
                    idTipoSolicitud: data?.idTipoSolicitud || '',
                    idTipoDoc: data?.idTipoDoc || '',
                    obligatorio: data?.obligatorio || false,
                })}
                formStructure={({ formValues, handleInputChange, setearValor }) => [
                    {
                        grid: {xs: 12, md:5},
                        Component: (
                            <SelectValidatorGeneric
                                label="Tipo Solicitud"
                                variant="outlined"
                                name="idTipoSolicitud"
                                value={formValues.idTipoSolicitud}
                                onChange={handleInputChange}
                                menuItems={tiposSolicitudes.map((item) => ({
                                    value: item.idTipo,
                                    label: item.descripcion
                                }))}
                                validations={[required]}
                            />
                        ),
                    },
                    {
                        grid: {xs: 12, md:5},
                        Component: (
                            <SelectValidatorGeneric
                                label="Tipo Documentación"
                                variant="outlined"
                                name="idTipoDoc"
                                value={formValues.idTipoDoc}
                                onChange={handleInputChange}
                                menuItems={tiposDocumentacion.map((item) => ({
                                    value: item.idTipoDoc,
                                    label: item.descripcion
                                }))}
                                validations={[required]}
                            />
                        ),
                    },
                    {
                        grid: {xs: 12, md:2, style: {display: "flex", justifyContent: "center", alignItems: "center"}},
                        Component: (
                            <>
                                <Typography style={{color: "#777"}}>Obligatorio</Typography>
                                <Checkbox
                                    checked={formValues.obligatorio}
                                    value={formValues.obligatorio}
                                    name="obligatorio"
                                    inputProps={{ 'aria-labelledby': formValues.idTipoDocSolicitud }}
                                    onClick={(e) => {setearValor("obligatorio", e.target.checked)}}
                                />
                            </>
                        ),
                    },
                ]}
                dataTable={{
                    list: tiposDocumentacionAbm.map(item => ({...item, id: item.idTipoDocSolicitud})),
                    columns: [
                        {
                            label: "Tipo Solicitud",
                            customBody: (item) => item?.tipoSolicitudIntegracion?.descripcion
                        },
                        {
                            label: 'Tipo Documentación',
                            customBody: (item) => item?.tipoDocumentacion?.descripcion
                        },
                        {
                            label: 'Obligatorio',
                            id: 'obligatorio',
                            customBody: (item) => (
                                <Checkbox
                                    checked={item.obligatorio}
                                    value={item.obligatorio}
                                    inputProps={{ 'aria-labelledby': item.idTipoDocSolicitud }}
                                    onClick={(e) => {
                                        dispatch(guardarTipoDocumentacionSolicitudIntegracion({
                                            ...item,
                                            obligatorio: e.target.checked
                                        }))
                                    }}
                                />
                            )
                        },
                    ],
                }}
                submit={(formValues, handleClose) => {
                    dispatch(guardarTipoDocumentacionSolicitudIntegracion(formValues, handleClose));
                }}
                deleteButton={(id, handleClose) => {
                    dispatch(deleteTipoDocumentacionSolicitudIntegracion(id, handleClose));
                }}
            />
        </div>
    );
};
